/* ARRAY - FREE SAMPLES AND THE DELUXE GIFT AS REAL BAG LINES. 18 Oct 2026.
   Loaded on every page from snippets/beyondads-rewards-launcher.liquid.

   Client feedback: "free samples aren't showing on the customer's checkout, and
   when packing orders nothing shows what each customer earned". The rewards bar
   only DESCRIBED the milestones; nothing was ever added to the order.

   Now the milestones put real $0 lines in the bag, so they show in the bag, at
   checkout and on the order the team packs:
     $65   1 x Free Sample   (product array-free-sample)
     $135  + 1 x Deluxe Sample (product array-deluxe-gift, renamed from "Deluxe Gift" 2 Nov 2026)
   and a cart attribute "Rewards earned" (e.g. "1 free sample + 1 deluxe sample")
   that Shopify prints under the order's Additional details.

   QUALIFYING SPEND IS WORKED OUT EXACTLY LIKE THE BAR (snippets/beyondads-rewards
   .liquid): products after the winning money discount, delivery left out, and
   lines whose product type is "ARRAY Gift" left out - which is also why adding
   the samples can never change the spend and loop. KEEP THE NUMBERS IN STEP
   with that snippet and with beyondads-rewards-pdp.liquid.

   Every cart change (Horizon's cart:update - adds, quantity changes, removals -
   and discount:update - a code applied in the bag) and every page load re-checks the bag and only
   writes when something is out of line: samples added when a milestone is
   reached, taken away when the spend drops below it, put back if a shopper
   deletes them, reset if a shopper changes their quantity. */
(function () {
  'use strict';
  if (window.__baSamples) return;
  window.__baSamples = true;

  var SAMPLE = 67653973016873;   // Free Sample, $0, product type ARRAY Gift
  var GIFT = 67653973049641;     // Deluxe Sample, $0, product type ARRAY Gift
  var M1 = 6500, M2 = 8900, M3 = 13500, DELIVERY = 400;
  var SOURCE = 'beyondads-samples';

  function spend(cart) {
    var pre = 0, gift = 0;
    cart.items.forEach(function (it) {
      if (it.product_type === 'ARRAY Gift') gift += it.final_line_price;
      else pre += it.original_line_price;
    });
    var post = Math.max(0, cart.total_price - gift);
    var disc = Math.max(0, pre - post);
    if (disc > 0) {
      if (pre >= M2) return disc > DELIVERY ? post : pre;
      return post;
    }
    return pre;
  }

  function qtyOf(cart, id) {
    var n = 0;
    cart.items.forEach(function (it) { if (it.variant_id === id) n += it.quantity; });
    return n;
  }

  function label(s, g) {
    var out = [];
    if (s) out.push(s === 1 ? '1 free sample' : s + ' free samples');
    if (g) out.push('1 deluxe sample');
    return out.join(' + ');
  }

  function sectionIds() {
    var ids = [];
    var comps = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < comps.length; i++) if (comps[i].dataset && comps[i].dataset.sectionId) ids.push(comps[i].dataset.sectionId);
    return ids;
  }

  function announce(res) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: res, sourceId: SOURCE, data: { source: SOURCE, itemCount: res.item_count, sections: res.sections || {} } }
      }));
    } catch (e) {}
  }

  var busy = false, again = false, timer = null;

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var real = cart.items.some(function (it) { return it.product_type !== 'ARRAY Gift'; });
        var q = real ? spend(cart) : 0;
        var wantS = q >= M1 ? 1 : 0;
        var wantG = q >= M3 ? 1 : 0;
        var lab = label(wantS, wantG);
        var attr = (cart.attributes && cart.attributes['Rewards earned']) || '';
        if (qtyOf(cart, SAMPLE) === wantS && qtyOf(cart, GIFT) === wantG && attr === lab) return null;

        var body = { updates: {}, attributes: { 'Rewards earned': lab } };
        body.updates[SAMPLE] = wantS;
        body.updates[GIFT] = wantG;
        var ids = sectionIds();
        if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && !res.status && res.items) announce(res);
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; queue(); }
      });
  }

  function queue() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }

  /* cart:update = adds, quantity changes, removals. discount:update = a code
     applied or removed in the bag's Discount box (Horizon fires a separate event
     for that, and a code can push the spend under a milestone). */
  ['cart:update', 'discount:update'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var d = e && e.detail;
      if (d && (d.sourceId === SOURCE || (d.data && d.data.source === SOURCE))) return;
      queue();
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue);
  else queue();
})();
